import React, { useState, useEffect } from "react";
import { generateAyalaTransaction } from "../Helpers/apiCalls/authApi";

const ClockReport = () => {
    const [time, setTime] = useState(new Date());
    const now = new Date();
    
    async function submit(time) {
        const response = await generateAyalaTransaction(time);
        if (response.data) {
            
        }
    }
    
    
    const executeTask = () => {
        const time = new Date().toLocaleTimeString('en-US', { 
            hour12: false, 
            hour: '2-digit', 
            minute: '2-digit' 
        });        
        submit(time);
    };
    
    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (now.getMinutes() === 0 && now.getSeconds() === 5) {
            executeTask();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [now]);

    return (
        <div style={styles.clock}>
            {time.toLocaleTimeString('en-US', { hour12: false })}
        </div>
    );
};

const styles = {
  clock: {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    background: "#000",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "5px",
    fontSize: "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
};

export default ClockReport;
